import React from 'react'

import { MultiCheckbox } from '../../Form'
import { trackProductListFilterChange } from '../../../../utils/Alphapet/tracking'

export default function MultiSelectFilter({
  id,
  label,
  values,
  selectedValues,
  submitForms,
  categoryUrls,
  searchData,
}) {
  const formData = {
    name: id,
    value: selectedValues,
  }

  const options = Object.values(values)
    .filter(({ count }) => count > 0)
    .sort((a, b) => a.position > b.position)
    .map(({ key }) => ({
      label: key,
      value: key,
    }))

  const handleChange = (e) => {
    // Immediate submit
    submitForms({ resetPagination: true })
    trackProductListFilterChange(
      e.target.value,
      categoryUrls,
      searchData,
      e.target.checked
    )
  }

  return (
    <MultiCheckbox
      onChange={handleChange}
      data={formData}
      options={options}
      legend={label}
      legendClassName="sr-only"
    />
  )
}
